<template>
  <div>
    <AllSendOuts></AllSendOuts>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AllSendOuts = defineAsyncComponent(() =>
  import("@/components/sendOuts/AllSendOuts")
);
export default {
  components: {
    AllSendOuts,
  },
};
</script>
